export default __webpack_public_path__ + "static/media/writing-competition-banner.2ab82ab3.jpeg";